import { handleAsyncStatus } from 'affiny-core/modules/asynchronousState/saga';
import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getPaymentHistory } from '../api/repositories/payment/payment.sagas';
import { ActionsOfType } from '../helpers';
import {
  EPaymentHistoriesActionType,
  paymentHistoriesAction,
  TPaymentHistoriesAction,
} from './actions';

export function* getPaymentHistoriesSaga(
  action: ActionsOfType<
    TPaymentHistoriesAction,
    EPaymentHistoriesActionType.GET
  >
) {
  const paymentHistories = yield call(getPaymentHistory);

  yield put(
    paymentHistoriesAction.getPaymentHistoriesSuccess({
      entries: paymentHistories.histories,
    })
  );
}

export function* paymentHistoriesRootSaga() {
  yield all([
    takeLatest(
      EPaymentHistoriesActionType.GET,
      handleAsyncStatus(
        getPaymentHistoriesSaga,
        EAsyncEventTypes.PAYMENT_HISTORIES
      )
    ),
  ]);
}
